function slideUp(element: HTMLElement, duration: number = 500): void {
    element.style.transitionProperty = 'height, margin, padding';
    element.style.transitionDuration = `${duration}ms`;
    element.style.boxSizing = 'border-box';
    element.style.height = `${element.offsetHeight}px`;
    element.style.overflow = 'hidden';

    window.setTimeout((): any => {
        element.style.height = '0px';
        element.style.paddingTop = '0px';
        element.style.paddingBottom = '0px';
        element.style.marginTop = '0px';
        element.style.marginBottom = '0px';
    }, 1);

    window.setTimeout((): any => {
        element.style.display = 'none';
        element.style.removeProperty('height');
        element.style.removeProperty('padding-top');
        element.style.removeProperty('padding-bottom');
        element.style.removeProperty('margin-top');
        element.style.removeProperty('margin-bottom');
        element.style.removeProperty('overflow');
        element.style.removeProperty('transition-duration');
        element.style.removeProperty('transition-property');
    }, duration);
}

function slideDown(element: HTMLElement, duration: number = 500): void {
    element.style.removeProperty('display');

    let { display } = window.getComputedStyle(element);

    if (display === 'none') {
        display = 'block';
    }

    element.style.display = display;
    const height = element.offsetHeight;
    element.style.overflow = 'hidden';
    element.style.height = '0px';
    element.style.paddingTop = '0px';
    element.style.paddingBottom = '0px';
    element.style.marginTop = '0px';
    element.style.marginBottom = '0px';

    window.setTimeout((): any => {
        element.style.boxSizing = 'border-box';
        element.style.transitionProperty = 'height, margin, padding';
        element.style.transitionDuration = `${duration}ms`;
        element.style.height = `${height}px`;
        element.style.removeProperty('padding-top');
        element.style.removeProperty('padding-bottom');
        element.style.removeProperty('margin-top');
        element.style.removeProperty('margin-bottom');
    }, 1);

    window.setTimeout(function (): any {
        element.style.removeProperty('height');
        element.style.removeProperty('overflow');
        element.style.removeProperty('transition-duration');
        element.style.removeProperty('transition-property');
    }, duration);
}

function slideToggle(element: HTMLElement, duration: number = 500): void {
    const { display } = window.getComputedStyle(element);

    //
    if (display === 'none') {
        slideDown(element, duration);
    }
    //
    else {
        slideUp(element, duration);
    }
}

// ----------------------------------------------------------------------------

function fadeIn(element: HTMLElement, display?: string): void {
    element.style.opacity = '0';
    element.style.display = display ?? 'block';

    (function fade(): void {
        let value = parseFloat(element.style.opacity);

        value += 0.1;

        if (value < 1) {
            element.style.opacity = value.toString();
            requestAnimationFrame(fade);
            return;
        }

        element.style.opacity = '1';
    })();
}

function fadeOut(element: HTMLElement): void {
    element.style.opacity = '1';

    (function fade(): void {
        let value = parseFloat(element.style.opacity);

        value -= 0.1;

        if (value > 0) {
            element.style.opacity = value.toString();
            requestAnimationFrame(fade);
            return;
        }

        element.style.opacity = '0';
        element.style.display = 'none';
    })();
}

// ----------------------------------------------------------------------------

function setOpacity(element: HTMLElement, opacity: string): void {
    element.style.opacity = opacity;
    element.style.filter = `alpha(opacity=${opacity})`;
}

// ----------------------------------------------------------------------------

export { slideUp, slideDown, slideToggle, fadeIn, fadeOut, setOpacity };
